import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const BrandSwipeCardStyle = styled.div`
  padding: 0 15px;
  img {
    width: 100%;
  }

  .title {
    margin-top: 8px;
    font-weight: bold;
    letter-spacing: -0.1px;
    color: black;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .contents {
    font-size: 12px;
    letter-spacing: -0.1px;
    color: #9b9b9b;
    line-height: 1.5;
  }
`;
